import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { AppSidebarNav } from './AppSidebarNav'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import navigation from '../_nav'
import { setSidebar } from 'src/store/Slices/SidebarSlice'
import logo from '../assets/brand/LogoTMPL.svg'
import { useEffect } from 'react'
import { getMyInfo } from 'src/store/Slices/AuthSlice'
import { useLocation } from 'react-router-dom'
import { sygnet } from 'src/assets/brand/sygnet'

// Добавляем стили прямо в компонент
const hideScrollbarStyles = `
  .c-sidebar-nav {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  .c-sidebar-nav::-webkit-scrollbar {
    display: none !important;
  }
  .simplebar-scrollbar {
    display: none !important;
  }
  .simplebar-track.simplebar-vertical {
    display: none !important;
  }
  .sidebar-nav {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  .sidebar-nav::-webkit-scrollbar {
    display: none !important;
  }
`

const AppSidebar = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const unfoldable = useSelector((state) => state.sidebarSlice.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarSlice.sidebarShow)
  const myInfo = useSelector((state) => state.AuthSlice.myInfo)

  useEffect(() => {
    !myInfo && dispatch(getMyInfo({ username: localStorage.getItem('username') }))
  }, [pathname])

  // Добавляем стили при монтировании компонента
  useEffect(() => {
    const styleElement = document.createElement('style')
    styleElement.textContent = hideScrollbarStyles
    document.head.appendChild(styleElement)
    
    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  const filterMnemoPages = (mnemos) => {
    const arr = [];
    const formViews = myInfo?.data?.value?.formViews;
  
    if (!formViews) return arr;
  
    for (const formView of formViews) {
      const mnemo = formView.mnemo;
  
      if (mnemos.some(el => el.mnemo === mnemo)) {
        const el = mnemos.find(el => el.mnemo === mnemo);
  
        if (!el) continue;
  
        if (el.items) {
          const arrChildren = [];
          const children = formViews.find(c => c.mnemo === mnemo)?.children || [];
  
          for (const child of children) {
            const mnemoChild = child.mnemo;
            const item = el.items.find(elem => elem.mnemo === mnemoChild);
  
            if (item) {
              arrChildren.push(item);
            }
          }
  
          if (arrChildren.length > 0) {
            arr.push({ ...el, items: [...arrChildren] });
          }
        } else {
          arr.push(el);
        }
      }
    }
  
    return arr;
  };

  return (
    <>
      {myInfo && (
        <CSidebar
          position="fixed"
          unfoldable={unfoldable}
          visible={sidebarShow}
          
          onVisibleChange={(visible) => {
            dispatch(setSidebar({ sidebarShow: visible }));
          }}
        >
          <CSidebarBrand className="d-none d-md-flex" to="/">
            <img className='sidebar-brand-full' src={logo} alt="" />
            <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
          </CSidebarBrand>
          
          <CSidebarNav>
            <SimpleBar style={{ maxHeight: 'calc(100vh - 100px)', height: '100%' }}>
              <AppSidebarNav items={filterMnemoPages(navigation)} />
            </SimpleBar>
          </CSidebarNav>
          
          <CSidebarToggler
            className="d-none d-lg-flex"
            onClick={() => dispatch(setSidebar({ sidebarUnfoldable: !unfoldable }))}
          />
        </CSidebar>
      )}
    </>
  )
}

export default React.memo(AppSidebar)